import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { Ng1LoadedGuard } from '../shared/ng1/ng1-loaded.guard';
import { IvrComponent } from './ivr.component';
import { IvrListComponent } from './ivr-list/ivr-list.component';
import { IvrDetailsComponent } from './ivr-details/ivr-details.component';
import { IvrResolver } from './ivr-details/ivr.resolver';
import { IvrsResolver } from './ivrs.resolver';
import { IvrMsisdnsResolver } from './ivr-details/ivr-msisdns.resolver';
import { InboundableMsisdnResolver } from './inboundable-msisdns.resolver';

const routes: Routes = [
  {
    path: 'ivr',
    component: IvrComponent,
    canActivate: [Ng1LoadedGuard],
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['MANAGE_IVR_PERMISSION']
      }
    },
    children: [
      {
        path: '',
        component: IvrListComponent,
        resolve: {
          ivrs: IvrsResolver
        }
      },
      {
        path: 'add',
        component: IvrDetailsComponent,
        resolve: {
          msisdns: InboundableMsisdnResolver
        }
      },
      {
        path: ':id',
        component: IvrDetailsComponent,
        resolve: {
          ivr: IvrResolver,
          msisdns: InboundableMsisdnResolver,
          assignedMsisdns: IvrMsisdnsResolver
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IvrRoutingModule {}
